export const UNKNOWN_ERROR_OCCURRED = "An unknown error occurred";
export const PROBLEM_SUBMITTING_PAYMENT =
  "There was a problem submitting your payment. Please check your internet connection and try again.";
export const ERROR_OCCURRED_SUBMITTING_PAYMENT =
  "An error occurred submitting payment details";
export const VALIDATION_ERROR = "validation-error";
